import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { Application, Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { ApplicationField } from 'embed/components/ApplicationField/container'
import ApplicationSubmitButton from 'embed/components/ApplicationSubmitButton/container'
import { MortgageStep, Product } from 'even-ts-static'
import { useTheme } from 'embed/hooks'
const styles = require('embed/styles/application')

interface Props {
  application: Application
  onChange: (field: Field, value) => void
}

const ApplicationView: React.FC<Props> = (props) => {
  const { colorTextSecondary } = useTheme()
  return (
    <>
      <section className={styles.formSection}>
        <h2 className={styles.heading}>Your Info</h2>
        <ApplicationField product={Product.Mortgage} field={Fields.EmailAddress} />
        <ApplicationField product={Product.Mortgage} field={Fields.DateOfBirth} />
        <ApplicationField product={Product.Mortgage} field={Fields.FirstName} />
        <ApplicationField product={Product.Mortgage} field={Fields.LastName} />
        <ApplicationField product={Product.Mortgage} field={Fields.Zipcode} />
        <ApplicationField product={Product.Mortgage} field={Fields.City} />
        <ApplicationField product={Product.Mortgage} field={Fields.State} />
        <ApplicationField product={Product.Mortgage} field={Fields.AddressOne} />
        <ApplicationField product={Product.Mortgage} field={Fields.AddressTwo} />
        <ApplicationField product={Product.Mortgage} field={Fields.PhoneNumber} />
        <ApplicationField product={Product.Mortgage} field={Fields.SocialSecurityNumber}>
          <div
            className={classnames(
              styles.creditScore,
              css`
                color: ${colorTextSecondary};
              `,
            )}
          >
            This will NOT affect your credit score
          </div>
        </ApplicationField>
      </section>

      <section className={styles.formSection}>
        <h2 className={styles.heading}>Finanical Info</h2>
        <ApplicationField product={Product.Mortgage} field={Fields.CreditRating} />
        <ApplicationField product={Product.Mortgage} field={Fields.EmploymentStatus} />
        <ApplicationField product={Product.Mortgage} field={Fields.MonthlyIncome} />
        <ApplicationField product={Product.Mortgage} field={Fields.MonthlyDebt} />
        <ApplicationField product={Product.Mortgage} field={Fields.Assets} />
      </section>

      <section className={styles.formSection}>
        <h2 className={styles.heading}>Property Info</h2>
        <ApplicationField product={Product.Mortgage} field={Fields.TransactionType} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyZipcode} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyCity} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyState} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyCounty} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyAddressOne} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyAddressTwo} />
        <ApplicationField product={Product.Mortgage} field={Fields.NumberOfUnits} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyType} />
        <ApplicationField product={Product.Mortgage} field={Fields.PurchaseStatus} />
        <ApplicationField product={Product.Mortgage} field={Fields.ClosingDate} />
        <ApplicationField product={Product.Mortgage} field={Fields.PropertyUse} />
        <ApplicationField product={Product.Mortgage} field={Fields.PurchasePrice} />
        <ApplicationField product={Product.Mortgage} field={Fields.DownPaymentAmount} />
      </section>

      <ApplicationSubmitButton product={Product.Mortgage} nextStep={MortgageStep.Results} />
    </>
  )
}

export default ApplicationView
